import {Dialog, TextField} from "@mui/material";
import {useState} from "react";
import {
    FormattedFormRow,
    FormContainer,
    FormDialogActionButtons,
    MultipleLineError,
    DialogActions,
    DialogContent,
    FormattedDialogTitle,
} from "@dvrt/graphql-widgets";
import CreateAnotherCheckBox from "../../CreateAnotherCheckBox";
import {useForm} from "@/utils/Form";
import ErrorHelper from "../../../utils/ErrorHelper";
import {showNotification} from "../../../actions";
import {defineMessage} from "react-intl";
import {Link} from "../../widgets";
import {useSavePickupGroupMutation} from "../queries.generated";

export type Props = {
    domainId: number;
    onSuccess: () => void;
    close: () => void;
    show: boolean;
};

export default ({domainId, onSuccess, show, close}: Props) => {
    const form = useForm(useSavePickupGroupMutation, "savePickupGroup", {domainId, name: ""}, (_form) =>
        showNotification(
            defineMessage({
                id: "pickup_group_created",
                defaultMessage: "Pickup group {link} has been successfully created.",
            }),
            "success",
            {
                link: (
                    <Link to={`/domains/${domainId}/pickup-groups/${_form.result.data.savePickupGroup.id}/settings`}>
                        {_form.values.name}
                    </Link>
                ),
            },
            10000,
        ),
    );
    const errorHelper = new ErrorHelper(form.errors);
    const [createAnother, setCreateAnother] = useState(false);

    function handleClose() {
        close();
        form.reset();
    }

    async function submit() {
        if (!(await form.submit())) return;
        onSuccess();
        if (createAnother) {
            form.reset();
        } else {
            handleClose();
        }
    }

    return (
        <Dialog open={show}>
            <FormattedDialogTitle title={defineMessage({id: "new_pickup_group", defaultMessage: "New pickup group"})} />
            <DialogContent>
                <FormContainer>
                    <FormattedFormRow label={defineMessage({id: "name", defaultMessage: "Name"})}>
                        <TextField
                            variant="standard"
                            margin="dense"
                            value={form.values.name}
                            onChange={(event) => form.updateValues({name: event.target.value})}
                            error={errorHelper.hasError("name")}
                            helperText={<MultipleLineError errors={errorHelper.fieldErrors("name")} />}
                        />
                    </FormattedFormRow>
                </FormContainer>
            </DialogContent>
            <DialogActions>
                <CreateAnotherCheckBox state={createAnother} setState={setCreateAnother} />
                <FormDialogActionButtons
                    mainAction={submit}
                    secondaryAction={() => form.reset()}
                    cancel={close}
                    enabled={form.hasChanged}
                />
            </DialogActions>
        </Dialog>
    );
};
